import { DrawerLayout } from '@/components/layouts/DrawerLayout.jsx';
import { useCreateIngredientMutation } from '../api';
import { newIngredient } from '../schema';
import { IngredientForm } from '../components/IngredientForm';
import { useDefaultSubcategoryId } from '@/features/categories/hooks/useDefaultSubcategoryId';

export function CreateIngredientPage() {
  const defaultSubcategoryId = useDefaultSubcategoryId();
  const data = {
    ...newIngredient(),
    subcategory_id: defaultSubcategoryId,
  };
  const [saveIngredient, saveResult] = useCreateIngredientMutation();

  function save(data) {
    return saveIngredient({ data });
  }

  return (    
    <DrawerLayout title="Create New Ingredient">      
      <IngredientForm data={data} save={save} saveResult={saveResult} />
    </DrawerLayout>
  );
}
